module.exports = __webpack_public_path__ + "img/silver_shine.61ac5066.png";